import { FunctionComponent } from 'react';
import QuestStatusBadge from '../QuestStatusBadge';
import {
    BeehiveHumanReviewStatus,
    BEEHIVE_HUMAN_REVIEW_TEXT,
    resolveBeehiveHumanReviewStatus
} from 'src/types/quests';
import { getBeehiveHumanReviewStatusColors } from 'src/utils/questStatusColors';

interface Props {
    status: BeehiveHumanReviewStatus | null | undefined;
}

const BeehiveHumanReviewBadge: FunctionComponent<Props> = ({ status }) => {
    const resolvedStatus = resolveBeehiveHumanReviewStatus(status);
    const colors = getBeehiveHumanReviewStatusColors(resolvedStatus);
    return (
        <QuestStatusBadge
            text={BEEHIVE_HUMAN_REVIEW_TEXT[resolvedStatus]}
            color={colors.color}
            backgroundColor={colors.backgroundColor}
        />
    );
};

export default BeehiveHumanReviewBadge;
